<template>
  <el-table :data="tableData" border style="width: 100%" :maxHeight="maxHeight">
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="scoreInterval"
      label="积分值区间"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="memberCount"
      label="会员数"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="memberRatio"
      label="会员数占比"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="tradeCount"
      label="会员成交人数"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="tradeTimes"
      label="会员成交单量"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="tradeAmount"
      label="会员成交金额"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="tradeAvgAmount"
      label="客单价"
      min-width="120"
      align="right"
    />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  name: "memberPointsAnalysis",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "scoreInterval") {
            newRow[key] = row[key];
            return;
          }
          // Ratio 字段 → 百分比
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            // 其他数值 → 普通数字
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
  },
};
</script>
